import TabPanel from '@/components/Tabs/TabPanel';
import styled from 'styled-components';

export const FormModePanel = styled(TabPanel)`
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
